import React from 'react';
import ReactDOM from 'react-dom';

import ProductSlider from '../SliderLib/ProductSlider/components/ProductSlider';
import client from '../utils/client';
import gtmPusher from '../utils/gtmPusher';
import getUid from '../utils/snowplow';
import uuid4 from '../utils/uuid';

export default class ProductSliderContainer extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      refId: uuid4(),
      items: [],
      loading: false,
      loaded: false
    };
  }

  componentDidMount() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      // Create intersectionObserver
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      const observer = new window.IntersectionObserver(this.callback, options);
      const target = this.ref.current;
      observer.observe(target);
    } else {
      this.loadItems();
    }
  }

  // this method is faulty on iOS until future investigation it will be commented
  // componentDidUpdate(prevProps) {
  //   if (this.props.algorithmOptions !== prevProps.algorithmOptions) {
  //     this.setState({
  //       refId: uuid4(),
  //       loaded: false,
  //     }, () => {
  //       this.loadItems();
  //     });
  //   }
  // }

  callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.loadItems();
        if (observer) {
          observer.disconnect();
        }
      }
    });
  };

  loadItems() {
    if (this.state.loaded || this.state.loading) {
      return;
    }
    this.setState({ loading: true });

    let recommendationsFetch;
    if (this.props.algorithm === 'product-list') {
      recommendationsFetch = client.get(`/api/products/batch/`, {
        params: { list: this.props.algorithmOptions.productIds.join(',') }
      });
    } else {
      recommendationsFetch = client.get(
        `/api/recommendations/${this.props.algorithm}/`,
        {
          params: {
            ...this.props.algorithmOptions
          }
        }
      );
    }

    recommendationsFetch.then(recommendations => {
      // There's a slight difference in the responses between the recommendation APIs and the batch product list.
      const products = recommendations.data.data
        ? recommendations.data.data.results
        : recommendations.data.products;
      const productIds = products.map(i => i.product_id);
      if (products.length > 0) {
        if (window.ua) {
          window.ua(
            'trackStructEvent',
            'slider',
            'display',
            this.state.refId,
            productIds
          );
        }
        // GOOGLE ANALYTICS
        const ecommerceObj = {
          event: 'impressionView',
          eventCategory: 'ecommerce',
          eventAction: 'impression view',
          eventLabel: 'list',
          eventValue: 0,
          eventNonInteraction: true,
          currencyCode: products.length > 0 ? products[0].currency : 'N/A',
          list: `product slider: ${this.props.algorithm}`
        };
        const productArr = products.map((product, i) => {
          return {
            ...product,
            product_id: product.id,
            product: product.name,
            quantity: 1,
            unit_net: product.prices.min_price,
            size: null,
            variant: '',
            position: i
          };
        });
        gtmPusher(ecommerceObj, productArr);
        // -- END GOOGLE ANALYTICS --
        this.setState({
          items: products,
          loaded: true,
          loading: false
        });
      }
    });
  }

  render() {
    const titleElement = this.props.title ? (
      <h2 className="sliderHeader">{this.props.title}</h2>
    ) : (
      ''
    );
    return (
      <div ref={this.ref}>
        {this.state.items.length > 0 && (
          <div>
            {titleElement}
            <ProductSlider
              refId={this.state.refId}
              products={this.state.items}
              // addToCartForm={this.props.addToCartForm}
              sliderType={this.props.algorithm}
              productClick={this.props.productClick}
            />
          </div>
        )}
      </div>
    );
  }
}

if (window.productSliders) {
  window.productSliders.forEach(productSlider => {
    ReactDOM.render(
      <ProductSliderContainer
        title={productSlider.title}
        algorithm={productSlider.algorithm}
        algorithmOptions={productSlider.algorithmOptions}
        // addToCartForm={productSlider.addToCartForm}
      />,
      productSlider.mountPoint
    );
  });
}
